var t;!function(t){t.production="production",t.stage="stage",t.development="development",t.local="local",t.bitbucket="bitbucket"}(t||(t={}));export{t as EnvironmentEnum};
//# sourceMappingURL=environmentEnums.js.map
